import HttpMethod from 'sources/http-methods';

export class PzCampaignSource {
  public async getCampaign(programName: string) {
    return await fetch(`/api/v1/pz/campaign/${programName}`, {
      method: HttpMethod.GET,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((campaign) => {
        return campaign;
      })
      .catch((err) => {
        throw err;
      });
  }
}
